import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.mobile,
        width: _vm.dialogWidth,
        persistent: "",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [
                _vm._t(
                  "verdict_activator",
                  function () {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          _vm._b(
                            {},
                            "v-btn",
                            { ...attrs, ..._vm.getActivatorButtonProps },
                            false
                          ),
                          on
                        ),
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.getActivatorButtonProps.buttonText) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  null,
                  {
                    attrs,
                    on,
                  }
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        VCard,
        [
          _c(VCol, { staticClass: "pt-5 text-h5", attrs: { cols: "12" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("components.AtReportVerdictDialog.form_title")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("AtForm", {
                attrs: { "cancel-btn": "", def: _vm.formDef },
                on: { onSubmit: _vm.submit, onCancel: _vm.onFormCancel },
                scopedSlots: _vm._u([
                  {
                    key: "AtDuration",
                    fn: function ({ props, update }) {
                      return [
                        _c(
                          "AtDuration",
                          _vm._b(
                            { on: { input: update } },
                            "AtDuration",
                            props,
                            false
                          )
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.getValue,
                  callback: function ($$v) {
                    _vm.getValue = $$v
                  },
                  expression: "getValue",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }